import type { AxiosResponse } from "axios"

type DuplicateCheckBody = {
  responseStatus?: number
}

/** BE duplicate checks return responseStatus 409; body status may still be "Ok" (BaseResponse quirk). */
export function isDuplicateRegistrationConflict(
  res: Pick<AxiosResponse<DuplicateCheckBody>, "data">
): boolean {
  return res?.data?.responseStatus === 409
}
